<template>
	<div>
		<div v-if="translate_status == '0'" style="display: flex;align-items: center;position: relative;z-index: 100;">
			<!-- <img style="object-fit: contain;"
				v-if="selectdItem.preStyle.fontIcon && selectdItem.preStyle.fontIcon.currency" :style="{
				width:(selectdItem.preStyle.font.size + 6) + 'px',
				height:(selectdItem.preStyle.font.size + 6) + 'px',
			}" :src="'https://shop910.com/' + currencyItem.url" /> -->

			<div style="margin-top: 0px;" class="notranslate" :style="{
				color:selectdItem.preStyle.font.color,
				fontSize:selectdItem.preStyle.font.size + 'px'
			}">
				{{currencyItem.symbol_left}}
			</div>

			<select @mouseleave.stop.prevent="entCurrency = false" @mouseenter.stop.prevent="entCurrency = true"
				@change="currencyChange" style="margin-left: 4px;cursor: pointer;margin: 0px;background-color: rgb(0 0 0 / 0%);"
				:style="{'--fontColor':entCurrency?compontentStyle.hoverColor?compontentStyle.hoverColor:selectdItem.preStyle.font.color:selectdItem.preStyle.font.color,'--fontSize':selectdItem.preStyle.font.size + 'px','--fontFamily':selectdItem.preStyle.font.fontFamily,fontStyle:selectdItem.preStyle.font.italic?'italic':'none'}"
				class="select-font" v-model="currency" name="cars" id="cars">
				<option style="color: #000000;" v-for="(item,index) in currency_list" :key="index" :value="item.code">
					<span class="notranslate" style="color: #000000;">{{item.code}}</span>
				</option>
			</select>
		</div>
		<div v-if="translate_status == '0'"
			style="display: flex;align-items: center;margin-left: 10px;position: relative;z-index: 100;">
			<img style="object-fit: contain;"
				v-if="selectdItem.preStyle.fontIcon && selectdItem.preStyle.fontIcon.locale" :style="{
				 width:(selectdItem.preStyle.font.size + 12) + 'px',
				 height:(selectdItem.preStyle.font.size - 2) + 'px',
			 }" :src="'https://shop910.com/' + localeItem.url" />
			<select @mouseleave.stop.prevent="entLocal = false" @mouseenter.stop.prevent="entLocal = true"
				@change="currencyLocale" style="margin-left: 4px;cursor: pointer;"
				:style="{
					...getSelectWidth(),
					'--fontColor':entLocal?compontentStyle.hoverColor?compontentStyle.hoverColor:selectdItem.preStyle.font.color:selectdItem.preStyle.font.color,'--fontSize':selectdItem.preStyle.font.size + 'px','--fontFamily':selectdItem.preStyle.font.fontFamily,fontStyle:selectdItem.preStyle.font.italic?'italic':'none'}"
				class="select-font notranslate" translate="no" v-model="locale" name="cars" id="cars">
				<option style="color: #000000;width: fit-content;" :key="index" v-for="(item,index) in locale_list"
					:value="item.code">
					<span translate="no" style="color: #000000;width: 50px;">{{item.name}}</span>
				</option>
			</select>
		</div>


		<div v-if="translate_status != '0'" style="display: flex;align-items: center;position: relative;z-index: 100;">
			<div style="margin-top: 0px;" class="notranslate" :style="{
				color:selectdItem.preStyle.font.color,
				fontSize:selectdItem.preStyle.font.size + 'px'
			}">
				{{currencyItem.symbol_left}}
			</div>
			<select @mouseleave.stop.prevent="entCurrency = false" @mouseenter.stop.prevent="entCurrency = true"
				@change="currencyChange" style="margin-left: 4px;cursor: pointer;margin: 0px;background-color: rgb(0 0 0 / 0%);"
				:style="{'--fontColor':entCurrency?compontentStyle.hoverColor?compontentStyle.hoverColor:selectdItem.preStyle.font.color:selectdItem.preStyle.font.color,'--fontSize':selectdItem.preStyle.font.size + 'px','--fontFamily':selectdItem.preStyle.font.fontFamily,fontStyle:selectdItem.preStyle.font.italic?'italic':'none'}"
				class="select-font curreny" v-model="currency" name="cars" id="cars">
				<option style="color: #000000;" v-for="(item,index) in currency_list" :key="index" :value="item.code">
					<span class="notranslate" style="color: #000000;">{{item.code}}</span>
				</option>
			</select>
		</div>
		<div v-if="translate_status != '0'"
			style="display: flex;align-items: center;margin-left: 10px;position: relative;z-index: 100;">
			<img v-if="translate_status != '1'" style="object-fit: contain;" :style="{
				 width:(selectdItem.preStyle.font.size + 12) + 'px',
				 height:(selectdItem.preStyle.font.size - 2) + 'px',
			 }" :src="flagUrl" />
			<!-- <div></div> -->
			<div id='google_translate_element' style="display: none;"></div>
			<div id="google_tr" style="cursor: pointer;">
			</div>
			<!-- <select @mouseleave.stop.prevent="entLocal = false" @mouseenter.stop.prevent="entLocal = true"
				@change="currencyLocale" style="margin-left: 4px;cursor: pointer;"
				:style="{'--fontColor':entLocal?compontentStyle.hoverColor?compontentStyle.hoverColor:selectdItem.preStyle.font.color:selectdItem.preStyle.font.color,'--fontSize':selectdItem.preStyle.font.size + 'px','--fontFamily':selectdItem.preStyle.font.fontFamily,fontStyle:selectdItem.preStyle.font.italic?'italic':'none'}"
				class="select-font" v-model="selectLanguage" name="cars" id="cars">
				<option style="color: #000000;" :key="index" v-for="(item,index) in translate_list" :value="item.value">
					<span style="color: #000000;">{{item.name}}</span>
				</option>
			</select> -->
		</div>

	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions,
		mapMutations
	} from 'vuex';
	import {
		getSetting,
		getSetLocale,
		getSetCurrency
	} from '../../api/all.js'
	export default {
		props: {
			equipment: {
				type: String,
				default: "pc"
			},
			translate_status: {
				type: String,
				default: '0'
			},
			translate_list: {
				type: Array,
				default: () => {
					return []
				}
			},
			compontentStyle: {
				type: Object,
				default: () => {
					return {}
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				entCurrency: false,
				entLocal: false,
				currencyItem: {},
				localeItem: {},
				currency_list: [],
				locale_list: [],
				currency: "",
				locale: "",
				langTime: null,
				langTime1: null,
				flagUrl: ""
			}
		},
		computed: {
			...mapState("lowCodeStore", ['systemLanguage', 'selectLanguage']),

		},
		async mounted() {
			if(!this.selectdItem.preStyle.iptSelectW) {
				this.$set(this.selectdItem.preStyle,'iptSelectW','')
			}
			
			
			let that = this
			that.getFlagUrl()
			console.log('this.type', this.type)
			console.log(' this.systemConfig', this.systemConfig)
			this.locale = this.systemConfig.locale
			this.currency = this.systemConfig.currency
			this.locale_list = this.systemConfig.locale_list
			this.locale_list.forEach(item => {
				if (item.code == this.locale) {
					this.localeItem = item
				}
			})


			console.log('this.locale_list', this.locale_list)
			this.currency_list = this.systemConfig.currency_list
			this.currency_list.forEach(item => {
				if (item.code == this.currency) {
					this.currencyItem = item
				}
			})


			if (this.translate_status == '2') {
				this.langTime = setInterval(() => {
					if (document.querySelector(".goog-te-gadget")) {
						try {
							let goog_te_gadget = document.querySelector(".goog-te-combo")



							let curreny = document.querySelector(".curreny")
							console.log('curreny', curreny)
							curreny.style.width = "50px"

							let google_tr = document.querySelector("#google_tr")
							const options = goog_te_gadget.options; // NodeList
							goog_te_gadget.style.backgroundColor = 'rgb(0 0 0 / 0%)'
							goog_te_gadget.style.border = '0px'
							
							if(this.selectdItem.preStyle.iptSelectW){
								goog_te_gadget.style.width = this.selectdItem.preStyle.iptSelectW + 'px'
							}else{
								goog_te_gadget.style.width = "100px"
							}
							
							// if (that.equipment == 'pc') {
							// 	goog_te_gadget.style.width = "100px"
							// } else {
							// 	goog_te_gadget.style.width = "100px"
							// }


							goog_te_gadget.addEventListener('change', function(event) {
								console.log('eventeventeventevent', event)
								console.log(that.$cookies.get('googtrans'))
								that.getFlagUrl()
							})



							goog_te_gadget.style.cursor = 'pointer'
							goog_te_gadget.style.fontSize = that.selectdItem.preStyle.font.size + 'px'
							goog_te_gadget.style.fontFamily = that.selectdItem.preStyle.font.fontFamily
							goog_te_gadget.style.color = that.entLocal ? that.compontentStyle.hoverColor ?
								that.compontentStyle.hoverColor : that.selectdItem.preStyle.font.color : that
								.selectdItem
								.preStyle.font.color

							console.log('this.compontentStyle', that.compontentStyle)
							goog_te_gadget.addEventListener('mouseover', function() {
								that.entLocal = true
								goog_te_gadget.style.color = that.entLocal ? that.compontentStyle
									.hoverColor ?
									that.compontentStyle.hoverColor : that.selectdItem.preStyle.font
									.color : that.selectdItem
									.preStyle.font.color
							})
							goog_te_gadget.addEventListener('mouseleave', function() {
								that.entLocal = false
								goog_te_gadget.style.color = that.entLocal ? that.compontentStyle
									.hoverColor ?
									that.compontentStyle.hoverColor : that.selectdItem.preStyle.font
									.color : that.selectdItem
									.preStyle.font.color

							})


							goog_te_gadget.style.fontStyle = this.selectdItem.preStyle.font.italic ? 'italic' :
								'none'
							google_tr.appendChild(goog_te_gadget)

							clearInterval(this.langTime)
						} catch (e) {
							console.log('e', e)
							clearInterval(this.langTime)
						}
					}
				}, 0)


				this.langTime1 = setInterval(() => {
					if (document.querySelector(".goog-te-gadget")) {
						// document.querySelector("goog-te-gadget").remove()
						let goog_te_gadget = document.querySelector(".goog-te-combo")

						// console.log('this.hasFontChild(goog_te_gadget)',this.hasFontChild(goog_te_gadget))

						const options = goog_te_gadget.options; // NodeList
						if (options.length > 0) {
							for (let option of options) {
								option.style.color = '#000000';
							}
							// clearInterval(this.langTime1)
						}
					}
				}, 5)
			}

			if (this.translate_status != '0') {
				this.googleTranslateElementInit()
			}
		},
		methods: {
			getSelectWidth(){
				if(this.selectdItem.preStyle.iptSelectW){
					return {
						width:this.selectdItem.preStyle.iptSelectW + 'px'
					}
				}
			},
			hasFontChild(parent) {
				const children = parent.children;
				for (let i = 0; i < children.length; i++) {
					if (children[i].tagName === 'FONT') {
						return true; // 找到直接子元素中的 <font> 标签
					}
				}
				return false; // 未找到
			},


			getFlagUrl() {
				let that = this
				let lang = that.$cookies.get('googtrans')
				if (lang) {
					lang = lang.replace('/auto/', '')
					that.translate_list.forEach(item => {
						if (lang == item.value) {
							this.flagUrl = item.url
							console.log('langlanglanglang', lang)
						}
					})
				}
			},
			googleTranslateElementInit() {
				let includedLanguages = ''
				this.translate_list.forEach(item => {
					if (includedLanguages == '') {
						includedLanguages = item.value
					} else {
						includedLanguages = includedLanguages + ',' + item.value
					}
				})

				const systemLanguage = navigator.language || navigator.userLanguage;
				console.log("系统语言:", systemLanguage);
				new google.translate.TranslateElement({
					pageLanguage: 'auto',
					// target: systemLanguage,
					includedLanguages,
					layout: google.translate.TranslateElement.FloatPosition.BOTTOM_LEFT,
					// gaTrack: true,
				}, 'google_translate_element');
			},
			async currencyChange(e) {
				console.log('e', e)
				await getSetCurrency({
					currency: this.currency
				})
				window.location.reload()
			},
			async currencyLocale(e) {
				console.log('currencyLocale', e)
				await getSetLocale({
					locale: this.locale
				})
				window.location.reload()
			}
		}
	}
</script>

<style scoped lang="scss">
	.google_tr {
		select {
			option {
				color: #000
			}
		}
	}


	.select-font {
		background-color: transparent !important;
		//   border-color: rgba(255, 255, 255, 0.5);
		font-size: var(--fontSize);
		font-family: var(--fontFamily);
		color: var(--fontColor);
		border: 0px;

	}


	::v-deep .el-input__inner {
		background-color: transparent !important;
		//   border-color: rgba(255, 255, 255, 0.5);
		font-size: var(--fontSize);
		font-family: var(--fontFamily);
		color: var(--fontColor);
		height: 40px;
		// padding: 0px 6px;
		// width: fit-content;


	}

	::v-deep .el-input--suffix .el-input__inner {
		// padding-right: 4px;
		// width: fit-content;
		// width: 130px;

	}

	/**修改边框和字体颜色 */
	::v-deep .el-select {
		position: relative;
		width: 100px;

		.el-input {
			input {
				border: 0px;
				height: 40px;
				border-color: rgba(140, 98, 255, 1.0);
				color: var(--fontColor);
			}
		}
	}

	/**修改下拉图标颜色 */
	::v-deep .el-input__suffix {
		.el-input__suffix-inner {
			.el-icon-arrow-up:before {
				// color: rgba(0, 0, 0, 0.5);
				color: var(--fontColor);
				padding-left: 0.11rem;
			}
		}
	}
</style>